<template>
  <div class="productListContent">
    <b-row class="mb-4">
      <b-col class="d-flex align-items-center">
        <h4>{{$t('productSearch.searchResult')}}：</h4>
        <h5>{{searchInput}}</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(item, key) in productList" :key="key" cols="6" md="3">
        <Item
          :item="item"
          :showCategory="true"
          :baseUrl="baseUrl" />
      </b-col>
      <b-col cols="12" v-if="isLoading" class="my-5">
        <p class="text-center subcolor3">
          <b-spinner small type="grow" class="mb-1"></b-spinner>
          {{$t('productSearch.loadingMessage')}}
        </p>
      </b-col>
      <b-col cols="12" v-else-if="isFinish" class="my-5">
        <p class="text-center subcolor3">
          {{$t('productSearch.finishMessage')}}
        </p>
      </b-col>
    </b-row>
    <!-- <b-modal :id="'checkbox_List'" modal-class="checkboxModal" hide-footer>
      <template v-slot:modal-title>
        <p class="large mb-0">篩選</p>
      </template>
      <CheckBoxList title="品牌" :selected="allBrandSelected" :options="allBrand" />
      <button class="btn btn-primary w-100">套用</button>
    </b-modal>-->
  </div>
</template>

<script>
import Item from "../shared/Item";
export default {
  name: "Content",
  components: {
    Item
  },
  props: ["isLoading","isFinish","productList", "allBrand", "allBrandSelected","searchInput","baseUrl"],
  mounted() {
    console.log(this.productList);
  },
  methods: {
    loadMore: function() {
      this.$emit("loadMore");
    }
  }
};
</script>
